import axios from 'core/network/interceptor';
import { GetOffersUrl, GetOfferUrl, PostOfferUrl, PutOfferUrl } from './constants';

interface createOfferEntryVariables {
    data: any;
}

const CreateOfferRequest = async ({data}: createOfferEntryVariables) => {
    const response = await axios.post(PostOfferUrl, data);

    return response.data.offer;
};

const GetOfferRequest = async (offerId: number) => {
    const response = await axios.get(GetOfferUrl(offerId));

    return response.data.offer;
};

const GetOffersRequest = async () => {
    const response = await axios.get(GetOffersUrl);

    return response.data;
};

interface updateOfferEntryVariables {
    id: number;
    data: any;
}

const UpdateOfferRequest = async ({id, data}: updateOfferEntryVariables) : Promise<any>=> {
    const response = await axios.put(PutOfferUrl(id), data);

    return response.data.offer;
};

export { CreateOfferRequest, GetOfferRequest, GetOffersRequest, UpdateOfferRequest };